export default "__VITE_ASSET__DBXktYla__"